var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResidentialTenant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4847,
    cy: 13.2397,
    r: 12.5,
    fill: "#F64E60"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1191_361",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 6,
    width: 15,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.3396,
    y: 6.23975,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1191_361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50623 18.4897V11.4897L13.1729 7.98975L16.3083 10.3522C16.0653 10.3814 15.8368 10.4373 15.6229 10.52C15.409 10.6026 15.2048 10.712 15.0104 10.8481L13.1729 9.44808L9.67289 12.0731V17.3231H12.0062V18.4897H8.50623ZM13.1729 18.4897V17.3814C13.1729 17.1772 13.2239 16.9852 13.326 16.8054C13.4281 16.6255 13.5666 16.4821 13.7416 16.3752C14.1889 16.1127 14.658 15.9134 15.1489 15.7772C15.6399 15.6411 16.1479 15.5731 16.6729 15.5731C17.1979 15.5731 17.7059 15.6411 18.1969 15.7772C18.6878 15.9134 19.1569 16.1127 19.6041 16.3752C19.7791 16.4821 19.9177 16.6255 20.0198 16.8054C20.1219 16.9852 20.1729 17.1772 20.1729 17.3814V18.4897H13.1729ZM14.4271 17.3231H18.9187C18.5784 17.1286 18.2187 16.9828 17.8396 16.8856C17.4604 16.7884 17.0715 16.7397 16.6729 16.7397C16.2743 16.7397 15.8854 16.7884 15.5062 16.8856C15.1271 16.9828 14.7673 17.1286 14.4271 17.3231ZM16.6729 14.9897C16.1868 14.9897 15.7736 14.8196 15.4333 14.4793C15.093 14.1391 14.9229 13.7259 14.9229 13.2397C14.9229 12.7536 15.093 12.3404 15.4333 12.0002C15.7736 11.6599 16.1868 11.4897 16.6729 11.4897C17.159 11.4897 17.5722 11.6599 17.9125 12.0002C18.2528 12.3404 18.4229 12.7536 18.4229 13.2397C18.4229 13.7259 18.2528 14.1391 17.9125 14.4793C17.5722 14.8196 17.159 14.9897 16.6729 14.9897ZM16.6729 13.8231C16.8382 13.8231 16.9767 13.7672 17.0885 13.6554C17.2003 13.5436 17.2562 13.405 17.2562 13.2397C17.2562 13.0745 17.2003 12.9359 17.0885 12.8241C16.9767 12.7123 16.8382 12.6564 16.6729 12.6564C16.5076 12.6564 16.3691 12.7123 16.2573 12.8241C16.1455 12.9359 16.0896 13.0745 16.0896 13.2397C16.0896 13.405 16.1455 13.5436 16.2573 13.6554C16.3691 13.7672 16.5076 13.8231 16.6729 13.8231Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidentialTenant);
export default __webpack_public_path__ + "static/media/Residential_tenant.a0c4a96dcecfb6e904e4b427ce2091ed.svg";
export { ForwardRef as ReactComponent };